export default __webpack_public_path__ + "2fdae4f89d6891389865ee1a0b4d8c45.png";